import moment from 'moment';
import _ from 'underscore';

function PromoterSalesCtrl($scope, $state, $stateParams, $q, alertService, managementUserService, ERROR_MESSAGES, organizationService, mapperService, venueService, urlService, eventService, dateUtilsService, sdkUtils) { //eslint-disable-line
  const vm = this;

  $scope.currentDateUTC = $stateParams.date && _.isNumber(parseInt($stateParams.date, 10)) ? moment.utc(parseInt($stateParams.date, 10)) : moment.utc();
  vm.loading = true;

  $scope.venue = venueService.getCurrentVenue();
  $scope.venuesPromise = venueService.getCurrentVenues();

  $scope.venueId = $scope.venue.id;
  $scope.venuesPromise = $q.all([
      venueService.getCurrentVenues(),
      _getEvents()
    ])
    .then(results => {
      $scope.venues = results[0];
      $scope.events = results[1];
      $scope.eventsIndexedById = _.indexBy($scope.events, 'id');
      $scope.event = $stateParams.eventId ? _.findWhere($scope.events, {
        _id: $stateParams.eventId
      }) : null;
    });

  function _getEvents() {
    if (!$scope.venue) return null;

    return eventService.listByVenueId($scope.venue.id, {
        fields: 'venue(id), date, name, primaryImage, images',
        start: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
        end: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)));
  }
}

PromoterSalesCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'mapperService',
  'venueService',
  'urlService',
  'jsSdk.event',
  'dateUtilsService',
  'jsSdk.utils'
];

export default PromoterSalesCtrl;



// WEBPACK FOOTER //
// ./src/components/promoter/sales/salesCtrl.js